var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PagePlaceholder',{attrs:{"title":"Brand Analytics Page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }